import { mergeClassName as e } from "../../utils/data.js";
import t from "./Calendar.module.js";
import n from "../Input/InputBox.module.js";
import { inputBoxClassName as r } from "../Input/inputBoxClassName.js";
import "react";
import { jsxDEV as i } from "react/jsx-dev-runtime";
//#region lib/components/DatePicker/DateRangeInputTrigger.tsx
var a = "/opt/render/project/src/shared-ui/lib/components/DatePicker/DateRangeInputTrigger.tsx";
function o({ hasError: o, active: s, disabled: c, fromValue: l, toValue: u, fromPlaceholder: d, toPlaceholder: f, prefix: p, suffix: m, describedBy: h, id: g, className: _, onOpen: v, fromInputProps: y, toInputProps: b }) {
	let x = {
		role: "combobox",
		"aria-expanded": s ?? !1,
		"aria-haspopup": "dialog",
		"aria-describedby": h,
		onClick: () => {
			c || v();
		}
	};
	return /* @__PURE__ */ i("div", {
		className: r({
			hasError: o,
			active: s,
			disabled: c
		}, t.trigger, t.rangeTrigger, _),
		id: g,
		"data-disabled": c ?? void 0,
		...x,
		children: [
			p && /* @__PURE__ */ i("span", {
				className: n.adornment,
				"aria-hidden": !0,
				children: p
			}, void 0, !1, {
				fileName: a,
				lineNumber: 73,
				columnNumber: 17
			}, this),
			/* @__PURE__ */ i("input", {
				readOnly: !0,
				disabled: c,
				tabIndex: -1,
				value: l,
				placeholder: d,
				"aria-label": d ?? "From date",
				...y,
				className: e(n.input, t.rangeSegmentInput, y?.className)
			}, void 0, !1, {
				fileName: a,
				lineNumber: 77,
				columnNumber: 13
			}, this),
			/* @__PURE__ */ i("span", {
				className: t.rangeDivider,
				"aria-hidden": !0
			}, void 0, !1, {
				fileName: a,
				lineNumber: 87,
				columnNumber: 13
			}, this),
			/* @__PURE__ */ i("input", {
				readOnly: !0,
				disabled: c,
				tabIndex: -1,
				value: u,
				placeholder: f,
				"aria-label": f ?? "To date",
				...b,
				className: e(n.input, t.rangeSegmentInput, b?.className)
			}, void 0, !1, {
				fileName: a,
				lineNumber: 88,
				columnNumber: 13
			}, this),
			m && /* @__PURE__ */ i("span", {
				className: n.adornment,
				"aria-hidden": !0,
				children: m
			}, void 0, !1, {
				fileName: a,
				lineNumber: 99,
				columnNumber: 17
			}, this)
		]
	}, void 0, !0, {
		fileName: a,
		lineNumber: 61,
		columnNumber: 9
	}, this);
}
//#endregion
export { o as DateRangeInputTrigger };
